// frontend/src/components/historias/FormulariosDinamicos.jsx - VERSIÃ“N CORREGIDA CON PSICOTERAPIA
import React, { useState, useEffect, useRef } from 'react';
import {
  Box, Typography, Paper,  
  Button, CircularProgress, Alert, Chip, Grid, TextField, FormControl,
  InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Radio,
  RadioGroup, FormHelperText, LinearProgress, Card, CardContent,  
  Avatar, Fade, Collapse, IconButton, Tooltip, Stack,
  useTheme, useMediaQuery,  Divider,  
   Tabs, Tab, 
  SwipeableDrawer,
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  Save as SaveIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Assignment as AssignmentIcon,
  Person as PersonIcon,   
  Schedule as ScheduleIcon,
  Star as StarIcon,
  Info as InfoIcon,
  Edit as EditIcon,  
  ExpandLess as ExpandLessIcon,  
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  Close as CloseIcon,
  Menu as MenuIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Download as DownloadIcon,
  PictureAsPdf as PdfIcon,
  Link as LinkIcon
} from '@mui/icons-material';

import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { styled, keyframes } from '@mui/material/styles';
import formularioService from '../../services/formularioService';
import { useNotification } from '../../contexts/NotificationContext';
import { useAuth } from '../../hooks/useAuth';
import Swal from 'sweetalert2';
import TablaPlanTerapeutico from '../formularios/campos/TablaPlanTerapeutico';
import SeleccionObjetivoPadre from '../formularios/campos/SeleccionObjetivoPadre';
import TablaEvaluacionMensual from '../formularios/campos/TablaEvaluacionMensual';
import TablaMemoriaCompleja from '../formularios/campos/TablaMemoriaCompleja';
import TablaSeguimientoMensual from '../formularios/campos/TablaSeguimientoMensual';
import DashboardEstadisticoNeuro from '../formularios/campos/DashboardEstadisticoNeuro';

if (typeof window !== 'undefined') {
  window.sistemaBloqueoRecargas = {
    bloqueado: false,
    iniciarBloqueo: () => {
      window.sistemaBloqueoRecargas.bloqueado = true;

    },
    terminarBloqueo: () => {
      window.sistemaBloqueoRecargas.bloqueado = false;

    },
    estaBloqueado: () => window.sistemaBloqueoRecargas.bloqueado
  };
}


const guardarEstadoFormulario = (tabActual, etapaId, historiaEspecialidadId) => {
  const estado = {
    tabActual,
    etapaId,
    historiaEspecialidadId,
    timestamp: Date.now()
  };
  sessionStorage.setItem('formularios_estado', JSON.stringify(estado));

};

const restaurarEstadoFormulario = (etapaId, historiaEspecialidadId, totalFormularios) => {
  try {
    const estadoGuardado = sessionStorage.getItem('formularios_estado');
    if (estadoGuardado) {
      const estado = JSON.parse(estadoGuardado);
      
      // Verificar que sea de la misma etapa e historia, y no muy antiguo
      const esValido = estado.etapaId === etapaId && 
                      estado.historiaEspecialidadId === historiaEspecialidadId &&
                      (Date.now() - estado.timestamp) < 300000; // 5 minutos
      
      if (esValido && estado.tabActual < totalFormularios) {

        sessionStorage.removeItem('formularios_estado');
        return estado.tabActual;
      }
    }
  } catch (error) {
    console.error('Error al restaurar estado formulario:', error);
  }
  return 0; // Tab por defecto
};

const guardarEstadoTab = (tabValue, pacienteId) => {
  const estado = {
    tabValue,
    timestamp: Date.now(),
    pacienteId
  };
  sessionStorage.setItem('vistaHCE_estado', JSON.stringify(estado));

};

// Función para restaurar estado del tab
const restaurarEstadoTab = (pacienteId, totalTabs) => {
  try {
    const estadoGuardado = sessionStorage.getItem('vistaHCE_estado');
    if (estadoGuardado) {
      const estado = JSON.parse(estadoGuardado);
      
      // Verificar que sea del mismo paciente y no muy antiguo (5 minutos)
      const esValido = estado.pacienteId === pacienteId && 
                      (Date.now() - estado.timestamp) < 300000;
      
      if (esValido && estado.tabValue < totalTabs) {

        // Limpiar despuÃ©s de usar
        sessionStorage.removeItem('vistaHCE_estado');
        return estado.tabValue;
      }
    }
  } catch (error) {
    console.error('Error al restaurar estado:', error);
  }
  return 0; // Tab por defecto
};

// Componentes estilizados para tabs responsivos
const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 48,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
    borderRadius: '3px 3px 0 0',
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    minHeight: 48,
    padding: theme.spacing(1.5, 2),
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
      padding: theme.spacing(1, 1.5),
      minWidth: 100,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      padding: theme.spacing(1),
      minWidth: 80,
    },
    '&.Mui-selected': {
      color: theme.palette.primary.main,
    },
  },
}));

const TabPanel = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

const MobileDrawerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

// Componentes estilizados responsivos
const ResponsiveContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 1),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 0.5),
  },
}));

const InfoSection = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.light}08 0%, ${theme.palette.primary.main}12 100%)`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.primary.light}30`,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1.5),
    margin: theme.spacing(0, 1, 2, 1),
    borderRadius: theme.spacing(1.5),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    margin: theme.spacing(0, 0.5, 1.5, 0.5),
    borderRadius: theme.spacing(1),
  },
}));

const MobileFormField = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1.5),
  },
}));


const FormulariosDinamicos = ({ 
  historiaEspecialidadId,
  etapaId, 
  pacienteId, 
  especialidadId,
  onProgresoCambiado,
  pacienteInfo = null,
  etapaInfo = null,
  parentRespuestaId = null
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { showNotification } = useNotification();
  const { user } = useAuth();
  
  // ðŸ”§ MODIFICACIÃ“N 1: Detección de psicoterapia
  const esPsicoterapia = especialidadId === 2; // Ajustar segÃºn tu ID
  
  // Usar useRef para controlar si los datos ya se cargaron
  const datosInicializadosRef = useRef(false);
  const isUpdatingRef = useRef(false);
  
  // Estados
  const [loading, setLoading] = useState(true);
  const [formularios, setFormularios] = useState([]);
  const [respuestasExistentes, setRespuestasExistentes] = useState({});
  const [seccionesExpanded, setSeccionesExpanded] = useState({});
  const [datosFormularios, setDatosFormularios] = useState({});
  const [guardando, setGuardando] = useState({});
  const [mostrarInfo, setMostrarInfo] = useState(!isMobile);
  const [estadosFormularios, setEstadosFormularios] = useState({});
  const [procesandoEstado, setProcesandoEstado] = useState({});
  const [tabActual, setTabActual] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [procesandoPdf, setProcesandoPdf] = useState({});
  const [propsIniciales] = useState({ etapaId, historiaEspecialidadId }); // Guardar props iniciales
  const [parentRespuestaIdAutomatico, setParentRespuestaIdAutomatico] = useState(null);

  useEffect(() => {
    if (!historiaEspecialidadId || !etapaId) {
      console.error('Props requeridos faltantes:', { 
        historiaEspecialidadId, 
        etapaId, 
        pacienteId, 
        especialidadId 
      });
    }
  }, [historiaEspecialidadId, etapaId, pacienteId, especialidadId]);


  // Manejar cambio de tab
  const handleTabChange = (event, newValue) => {
   
    setTabActual(newValue);
    
    // ðŸ”§ GUARDAR ESTADO cada vez que cambie el tab
    guardarEstadoFormulario(newValue, etapaId, historiaEspecialidadId);
    
    if (isMobile) {
      setDrawerOpen(false);
    }
  };
  const mostrarDialogoAnalisisFuncional = async (objetivoId, formularioId) => {
  const { value: analisis } = await Swal.fire({
    title: 'AnÃ¡lisis Funcional Requerido',
    html: `
      <div style="text-align: left;">
        <p>Este objetivo ha tenido 3 sesiones consecutivas en proceso.</p>
        <p>Es necesario realizar un anÃ¡lisis funcional antes de continuar.</p>
        <textarea 
          id="analisis-funcional" 
          class="swal2-textarea" 
          placeholder="Describa el anÃ¡lisis funcional..."
          style="width: 100%; min-height: 150px;"
        ></textarea>
      </div>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Guardar AnÃ¡lisis',
    cancelButtonText: 'Cancelar',
    preConfirm: () => {
      const analisisTexto = document.getElementById('analisis-funcional').value;
      if (!analisisTexto) {
        Swal.showValidationMessage('Debe completar el anÃ¡lisis funcional');
      }
      return analisisTexto;
    }
  });
  
  if (analisis) {
    // Guardar el anÃ¡lisis funcional
    try {
      const respuestaId = respuestasExistentes[formularioId]?.id;
      if (respuestaId) {
        await formularioService.guardarAnalisisFuncional(respuestaId, objetivoId, analisis);
        showNotification('AnÃ¡lisis funcional guardado correctamente', 'success');
      }
    } catch (error) {
      console.error('Error al guardar anÃ¡lisis funcional:', error);
      showNotification('Error al guardar el anÃ¡lisis funcional', 'error');
    }
  }
};

  // Función para descargar plantilla vacía
const descargarPlantillaVacia = (formulario) => {
  try {
    // ACTIVAR BLOQUEO ANTES DE DESCARGA
    window.sistemaBloqueoRecargas.iniciarBloqueo();
    
    // Construir URL completa de la plantilla
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
    const plantillaUrl = `${baseUrl}${formulario.plantilla_pdf}`;
    
    // Crear link temporal para descarga
    const link = document.createElement('a');
    link.href = plantillaUrl;
    link.download = `${formulario.nombre}_plantilla.pdf`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    showNotification('Descargando plantilla...', 'info');
    
    // DESACTIVAR BLOQUEO DESPUÉS DE 3 SEGUNDOS
    setTimeout(() => {
      window.sistemaBloqueoRecargas.terminarBloqueo();
    }, 3000);
    
  } catch (error) {
    console.error('Error al descargar plantilla:', error);
    showNotification('Error al descargar la plantilla', 'error');
    // ASEGURAR DESBLOQUEO EN ERROR
    window.sistemaBloqueoRecargas.terminarBloqueo();
  }
};

// Función para generar PDF con datos
const generarPdfConDatos = async (formularioId, respuestaId) => {

  try {
        window.sistemaBloqueoRecargas.iniciarBloqueo();

    setProcesandoPdf(prev => ({ ...prev, [formularioId]: true }));
    
    // âœ… CONSTRUIR URL CORRECTA
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
    const url = `${baseUrl}/formularios/${formularioId}/respuestas/${respuestaId}/generar-pdf`;

    
    // âœ… HACER FETCH DIRECTO (NO usar formularioService)
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('âŒ Error response:', errorText);
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }
    
    // âœ… VERIFICAR QUE ES PDF
    const contentType = response.headers.get('content-type');
    
    if (!contentType?.includes('application/pdf')) {
      const responseText = await response.text();
      console.error('âŒ No es PDF, contenido:', responseText);
      throw new Error('La respuesta no es un PDF vÃ¡lido');
    }
    
    // âœ… CONVERTIR A BLOB Y ABRIR EN NUEVA VENTANA
    const blob = await response.blob();
    const pdfUrl = URL.createObjectURL(blob);
    window.open(pdfUrl, '_blank');

    showNotification('PDF generado correctamente', 'success');
    
    // Limpiar URL despuÃ©s de un tiempo
    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
    }, 10000);
    
    setTimeout(() => {
      window.sistemaBloqueoRecargas.terminarBloqueo();
    }, 3000);

  } catch (error) {
    console.error(' Error completo:', error);
    console.error(' Error stack:', error.stack);
    showNotification(`Error al generar PDF: ${error.message}`, 'error');
        window.sistemaBloqueoRecargas.terminarBloqueo();

    throw error; // Re-throw para debugging
  } finally {
    setProcesandoPdf(prev => ({ ...prev, [formularioId]: false }));
  }
};

  // Obtener color del chip segÃºn estado del formulario
  const getFormularioColor = (formulario) => {
    const respuesta = respuestasExistentes[formulario.id];
    if (!respuesta) return 'default';
    
    const estado = estadosFormularios[respuesta.id];
    if (estado === 'cerrado') return 'success';
    
    const datos = datosFormularios[formulario.id];
    if (datos && Object.keys(datos).length > 0) return 'warning';
    
    return 'default';
  };

  // Obtener icono segÃºn estado del formulario
  const getFormularioIcon = (formulario) => {
    const respuesta = respuestasExistentes[formulario.id];
    if (!respuesta) return <RadioButtonUncheckedIcon />;
    
    const estado = estadosFormularios[respuesta.id];
    if (estado === 'cerrado') return <LockIcon />;
    
    const datos = datosFormularios[formulario.id];
    if (datos && Object.keys(datos).length > 0) return <EditIcon />;
    
    return <RadioButtonUncheckedIcon />;
  };

  // Calcular progreso general
  const calcularProgreso = () => {
    if (formularios.length === 0) return 0;
    const completados = Object.keys(respuestasExistentes).length;
    return Math.round((completados / formularios.length) * 100);
  };

  // Componente de navegación móvil
  const MobileFormulariosDrawer = () => (
    <SwipeableDrawer
      anchor="bottom"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      onOpen={() => setDrawerOpen(true)}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxHeight: '80vh'
        }
      }}
    >
      <MobileDrawerHeader>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Seleccionar Formulario
        </Typography>
        <IconButton onClick={() => setDrawerOpen(false)}>
          <CloseIcon />
        </IconButton>
      </MobileDrawerHeader>
      
      <Box sx={{ p: 2, overflow: 'auto' }}>
        <Stack spacing={1}>
          {formularios.filter(f => f && f.id).map((formulario, index) => {
            const respuesta = respuestasExistentes[formulario.id];
            const estado = respuesta ? estadosFormularios[respuesta.id] : null;
            const isSelected = index === tabActual;
            
            return (
              <Card
                key={formulario.id}
                sx={{
                  cursor: 'pointer',
                  border: isSelected ? 2 : 1,
                  borderColor: isSelected ? 'primary.main' : 'divider',
                  bgcolor: isSelected ? 'primary.50' : 'background.paper',
                  opacity: estado === 'cerrado' ? 0.8 : 1,
                  '&:hover': {
                    bgcolor: isSelected ? 'primary.50' : 'action.hover',
                  }
                }}
                onClick={() => handleTabChange(null, index)}
              >
                <CardContent sx={{ py: 2 }}>
                  <Box display="flex" alignItems="center" gap={2}>
                    {getFormularioIcon(formulario)}
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {formulario.nombre}
                        {estado === 'cerrado' && ' (Cerrado)'}
                      </Typography>
                      {formulario.descripcion && (
                        <Typography variant="caption" color="textSecondary">
                          {formulario.descripcion}
                        </Typography>
                      )}
                    </Box>
                    <Stack direction="column" spacing={0.5} alignItems="flex-end">
                      {formulario.requerido_en_etapa && (
                        <Chip 
                          label="Requerido"
                          size="small"
                          color="warning"
                          icon={<StarIcon fontSize="small" />}
                        />
                      )}
                      <Chip 
                        label={estado === 'cerrado' ? 'Cerrado' : (respuesta ? 'En progreso' : 'Pendiente')}
                        size="small"
                        color={getFormularioColor(formulario)}
                      />
                    </Stack>
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Stack>
      </Box>
    </SwipeableDrawer>
  );

  // Cargar formularios y respuestas existentes
  useEffect(() => {
    const cargarDatos = async () => {

       if (window.sistemaBloqueoRecargas?.estaBloqueado()) {
   
          return;
        }
        
      if (!etapaId || !historiaEspecialidadId) {
        console.warn('CargarDatos: historiaEspecialidadId o etapaId faltante. No se cargarÃ¡n los formularios.');
        setLoading(false);
        return;
      }
      // Evitar recargar si estamos actualizando
      if (isUpdatingRef.current) {

        return;
      }
      
      if (datosInicializadosRef.current && 
          etapaId === propsIniciales.etapaId && 
          historiaEspecialidadId === propsIniciales.historiaEspecialidadId) {
       
        return;
      }
      
      if (!etapaId || !historiaEspecialidadId) {
        console.warn('Faltan parÃ¡metros necesarios:', { etapaId, historiaEspecialidadId });
        return;
      }
      
      try {
        setLoading(true);
        
        // 1. Cargar formularios de la etapa
        const formulariosRes = await formularioService.getFormulariosPorEtapa(etapaId);
        
        if (!formulariosRes || !formulariosRes.data) {
          console.error('Respuesta invÃ¡lida del servicio de formularios');
          setFormularios([]);
          setLoading(false);
          return;
        }

        const formulariosData = Array.isArray(formulariosRes.data?.formularios) ? 
          formulariosRes.data.formularios : [];
        
        const formulariosValidos = formulariosData.filter(f => {
          if (!f || typeof f !== 'object') {
            console.warn('Formulario invÃ¡lido:', f);
            return false;
          }
          if (!f.id) {
            console.warn('Formulario sin ID:', f);
            return false;
          }
          return true;
        });

        // Procesar estructura...
        const formulariosConEstructura = formulariosData
          .filter(formulario => formulario && formulario.id) // Filtrar elementos vÃ¡lidos
          .map(formulario => {
            let estructura;
            try {
              estructura = typeof formulario.estructura === 'string' 
                ? JSON.parse(formulario.estructura) 
                : (formulario.estructura || {});
            } catch (error) {
              console.error('Error al parsear estructura:', error);
              estructura = { campos: [], secciones: [] };
            }
            
            // Asegurar que campos y secciones sean arrays vÃ¡lidos
            estructura.campos = Array.isArray(estructura.campos) ? estructura.campos : [];
            estructura.secciones = Array.isArray(estructura.secciones) ? estructura.secciones : [];
            
            // Filtrar elementos vÃ¡lidos en campos y secciones
            estructura.campos = estructura.campos.filter(campo => campo && campo.id);
            estructura.secciones = estructura.secciones.filter(seccion => seccion && seccion.id);
            
            return {
              ...formulario,
              estructura
            };
          });

          // ðŸ”§ ORDENAMIENTO ESPECÃFICO POR ESPECIALIDAD
            const ordenarFormulariosPorEspecialidad = (formularios) => {
              return formularios.sort((a, b) => {
                const nombreA = a.nombre || '';
                const nombreB = b.nombre || '';
                
                // Definir orden para Neuropsicología
                const ordenNeuro = {
                  'Plan TerapÃ©utico Integral - Neuropsicología': 1,
                  'Plan de Intervención Mensual - Neuropsicología': 2
                };
                
                // Definir orden para Psicoterapia  
                const ordenPsico = {
                  'Plan TerapÃ©utico General - Psicoterapia': 1,
                  'Plan de Trabajo Mensual - Psicoterapia': 2
                };
                
                // Detectar especialidad (ajustar segÃºn tus IDs)
                const esNeuro = especialidadId === 1 || nombreA.toLowerCase().includes('neuropsicología') || nombreB.toLowerCase().includes('neuropsicología');
                const esPsico = especialidadId === 2 || nombreA.toLowerCase().includes('psicoterapia') || nombreB.toLowerCase().includes('psicoterapia');
                
                if (esNeuro) {
                  const prioridadA = ordenNeuro[nombreA] || 999;
                  const prioridadB = ordenNeuro[nombreB] || 999;
                  return prioridadA - prioridadB;
                } else if (esPsico) {
                  const prioridadA = ordenPsico[nombreA] || 999;
                  const prioridadB = ordenPsico[nombreB] || 999;
                  return prioridadA - prioridadB;
                }
                
                // Para otras especialidades, mantener orden alfabÃ©tico
                return nombreA.localeCompare(nombreB);
              });
            };

            // Aplicar ordenamiento
            const formulariosOrdenados = ordenarFormulariosPorEspecialidad(formulariosConEstructura);

        
        setFormularios(formulariosOrdenados);

        const tabRestaurado = restaurarEstadoFormulario(etapaId, historiaEspecialidadId, formulariosConEstructura.length);
       
        setTabActual(tabRestaurado);
        
        
        // 2. Cargar respuestas existentes (inline, no como función separada)
        try {
          const respuestasRes = await formularioService.getRespuestasPorHistoriaEspecialidad(historiaEspecialidadId);
          const respuestasData = respuestasRes.data || [];
          
          const respuestasMap = {};
          const datosMap = {};
          const estadosMap = {};
          
          respuestasData.forEach(respuesta => {
            respuestasMap[respuesta.formulario_id] = respuesta;
            estadosMap[respuesta.id] = respuesta.estado || 'abierto';
            
            if (respuesta.respuestas) {
              datosMap[respuesta.formulario_id] = typeof respuesta.respuestas === 'string' 
                ? JSON.parse(respuesta.respuestas)
                : respuesta.respuestas;
            }
          });
          
          setRespuestasExistentes(respuestasMap);
          
          // MODIFICACIÃ“N CLAVE: Preservar datos existentes en datosFormularios
          setDatosFormularios(prev => {
            // Si no había inicializado antes, usar datosMap
            if (!datosInicializadosRef.current) {
              return datosMap;
            }
            
            // Si ya había datos, preservar los actuales y solo actualizar con nuevos
            const nuevosDatos = { ...prev };
            Object.keys(datosMap).forEach(key => {
              // Solo actualizar si no hay datos mÃ¡s recientes en el estado actual
              if (!nuevosDatos[key] || Object.keys(nuevosDatos[key]).length === 0) {
                nuevosDatos[key] = datosMap[key];
              }
            });
            return nuevosDatos;
          });
          
          setEstadosFormularios(estadosMap);
        } catch (error) {
          console.error('Error al cargar respuestas:', error);
        }
        
        // Solo resetear el tab si realmente cambió la etapa
        if (!datosInicializadosRef.current || etapaId !== propsIniciales.etapaId) {
          if (tabActual >= formulariosConEstructura.length) {
            setTabActual(0);
          }
        }
        
        datosInicializadosRef.current = true;
        
        
      } catch (error) {
        console.error('Error al cargar formularios:', error);
        showNotification('Error al cargar formularios', 'error');
        setFormularios([]);
      } finally {
        setLoading(false);
      }
    };
    
    cargarDatos();
  }, [etapaId, historiaEspecialidadId]); // Solo dependencias esenciales


// Buscar formulario padre automÃ¡ticamente si es necesario
useEffect(() => {
  const buscarFormularioPadre = async () => {
    if (!formularios.length || parentRespuestaId) return;
    const formularioActual = formularios[tabActual];
    if (!formularioActual || !historiaEspecialidadId) {
      console.warn('Formulario actual o historiaEspecialidadId no disponible');
      return;
    }
    try {
      const respuestasRes = await formularioService.getRespuestasPorHistoriaEspecialidad(historiaEspecialidadId);
      // Procesar respuestas...
    } catch (error) {
      console.error('Error al buscar respuestas:', error);
    }
  };
  buscarFormularioPadre();
}, [formularios, tabActual, historiaEspecialidadId, parentRespuestaId, especialidadId]);

  // Cerrar formulario
  const cerrarFormulario = async (respuestaId, formularioNombre) => {
    try {
      const confirmado = await Swal.fire({
        title: 'Â¿Cerrar formulario?',
        text: `Â¿EstÃ¡ seguro de cerrar "${formularioNombre}"? Una vez cerrado, no podrÃ¡ editarlo.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, cerrar',
        cancelButtonText: 'Cancelar'
      });
      
      if (!confirmado.isConfirmed) return;
      
      // Marcar que estamos actualizando
      isUpdatingRef.current = true;
      
      setProcesandoEstado(prev => ({ ...prev, [respuestaId]: true }));
      
      const response = await formularioService.cerrarFormulario(respuestaId);
      
      if (response.success) {
        showNotification('Formulario cerrado correctamente', 'success');
        
        // Actualizar estado local sin recargar todo
        setEstadosFormularios(prev => ({
          ...prev,
          [respuestaId]: 'cerrado'
        }));
      }
    } catch (error) {
      console.error('Error al cerrar formulario:', error);
      showNotification('Error al cerrar el formulario', 'error');
    } finally {
      setProcesandoEstado(prev => ({ ...prev, [respuestaId]: false }));
      // Resetear flag despuÃ©s de un breve delay
      setTimeout(() => {
        isUpdatingRef.current = false;
      }, 100);
    }
  };

  useEffect(() => {
  const buscarFormularioPadreAutomatico = async () => {
    // Solo buscar si no tenemos parentRespuestaId como prop
    if (parentRespuestaId || !historiaEspecialidadId) {
      return;
    }

    try {
      const response = await formularioService.buscarPlanGeneralReciente(historiaEspecialidadId);
      
      if (response.success && response.data?.respuesta_id) {
        const padreReciente = response.data;

        // ESTA ES LA LÃNEA QUE FALTABA
        setDatosFormularios(prev => ({ 
          ...prev, 
          _parentRespuestaIdAutomatico: padreReciente.respuesta_id 
        }));
        setParentRespuestaIdAutomatico(padreReciente.respuesta_id);

      } else {
 
      }
    } catch (error) {
      console.error('Error al buscar formulario padre:', error);
    }
  };
  
  // Ejecutar solo despuÃ©s de que se hayan cargado los datos principales
  if (datosInicializadosRef.current && !loading) {
    buscarFormularioPadreAutomatico();
  }
}, [historiaEspecialidadId, parentRespuestaId, loading]);

  // ðŸ”§ MODIFICACIÃ“N 2: Nueva función para psicoterapia
  const reabrirYEditarPsicoterapia = async (respuestaId, formularioNombre) => {
  try {

    
    const confirmado = await Swal.fire({
      title: 'Â¿Reabrir formulario para edición?',
      text: `Â¿EstÃ¡ seguro de reabrir "${formularioNombre}" para continuar editando?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, reabrir y editar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmado.isConfirmed) {

      return;
    }
    

    // Marcar que estamos actualizando
    isUpdatingRef.current = true;
    setProcesandoEstado(prev => ({ ...prev, [respuestaId]: true }));
    

    const response = await formularioService.reabrirFormulario(respuestaId);
 
    if (response.success) {
      showNotification('Formulario reabierto para edición', 'success');
      
      // Actualizar estado local
      setEstadosFormularios(prev => ({
        ...prev,
        [respuestaId]: 'abierto'
      }));

    }
  } catch (error) {
    console.error('ðŸŽ¯ FRONTEND: ERROR:', error);
    console.error('ðŸŽ¯ FRONTEND: Error response:', error.response);
    console.error('ðŸŽ¯ FRONTEND: Error status:', error.response?.status);
    showNotification(error.response?.data?.message || 'Error al reabrir el formulario', 'error');
  } finally {
    setProcesandoEstado(prev => ({ ...prev, [respuestaId]: false }));
    setTimeout(() => {
      isUpdatingRef.current = false;
    }, 100);

  }
};

  // Reabrir formulario (solo admin)
  const reabrirFormulario = async (respuestaId, formularioNombre) => {
    try {
      const confirmado = await Swal.fire({
        title: 'Â¿Reabrir formulario?',
        text: `Â¿EstÃ¡ seguro de reabrir "${formularioNombre}"?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, reabrir',
        cancelButtonText: 'Cancelar'
      });
      
      if (!confirmado.isConfirmed) return;
      
      // Marcar que estamos actualizando
      isUpdatingRef.current = true;
      
      setProcesandoEstado(prev => ({ ...prev, [respuestaId]: true }));
      
      const response = await formularioService.reabrirFormulario(respuestaId);
      
      if (response.success) {
        showNotification('Formulario reabierto correctamente', 'success');
        
        // Actualizar estado local sin recargar todo
        setEstadosFormularios(prev => ({
          ...prev,
          [respuestaId]: 'abierto'
        }));
      }
    } catch (error) {
      console.error('Error al reabrir formulario:', error);
      showNotification(error.response?.data?.message || 'Error al reabrir el formulario', 'error');
    } finally {
      setProcesandoEstado(prev => ({ ...prev, [respuestaId]: false }));
      // Resetear flag despuÃ©s de un breve delay
      setTimeout(() => {
        isUpdatingRef.current = false;
      }, 100);
    }
  };

  // Manejar expansión de secciones
  const toggleSeccion = (formularioId, seccionId) => {
    const key = `${formularioId}-${seccionId}`;
    setSeccionesExpanded(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Manejar cambios en campos
  const handleCampoChange = (formularioId, campoId, valor) => {

    
    setDatosFormularios(prev => {
      const nuevosDatos = {
        ...prev,
        [formularioId]: {
          ...prev[formularioId],
          [campoId]: valor
        }
      };

      return nuevosDatos;
    });
  };

  window.bloqueandoRecargas = false;

  // Guardar sección
  const guardarSeccion = async (formularioId, seccionId) => {
  try {
    // ðŸ”¥ ACTIVAR BLOQUEO INMEDIATAMENTE
    window.sistemaBloqueoRecargas.iniciarBloqueo();
    
    setGuardando(prev => ({ ...prev, [`${formularioId}-${seccionId}`]: true }));
    
    const datosFormulario = datosFormularios[formularioId] || {};
    const parentIdAutomatico = datosFormularios._parentRespuestaIdAutomatico;

    const datosGuardar = {
      formulario_id: formularioId,
      historia_especialidad_id: historiaEspecialidadId,
      paciente_id: pacienteId,
      especialista_id: user?.especialistaId || user?.id || 1,
      respuestas: datosFormulario,
      fecha_completado: new Date().toISOString().split('T')[0],
      parent_respuesta_id: parentRespuestaId || parentIdAutomatico || null
    };
    
    const respuestaExistente = respuestasExistentes[formularioId];
    
    let response;
    if (respuestaExistente) {
      response = await formularioService.actualizarRespuesta(respuestaExistente.id, datosGuardar);
    } else {
      response = await formularioService.guardarRespuesta(datosGuardar);
    }
    
    // âœ… SOLO mostrar notificación - SIN actualizar estados
    showNotification('Sección guardada correctamente', 'success');
    
    
  } catch (error) {
    console.error('Error al guardar sección:', error);
    showNotification('Error al guardar la sección', 'error');
  } finally {
    setGuardando(prev => ({ ...prev, [`${formularioId}-${seccionId}`]: false }));
    
    // ðŸ”¥ DESACTIVAR BLOQUEO DESPUÃ‰S DE 5 SEGUNDOS
    setTimeout(() => {
      window.sistemaBloqueoRecargas.terminarBloqueo();
    }, 5000);
  }
};


  // Renderizar campo segÃºn tipo con diseÃ±o responsive
  const renderCampo = (formularioId, campo) => {
    const valor = datosFormularios[formularioId]?.[campo.id] || '';
    
    const respuestaExistente = respuestasExistentes[formularioId];
    const estaFormularioCerrado = respuestaExistente && estadosFormularios[respuestaExistente.id] === 'cerrado';
    const esAdmin = user?.rol_id === 1;

    const commonProps = {
      fullWidth: true,
      variant: "outlined",
      size: isSmallMobile ? "small" : "medium",
      sx: {
        '& .MuiOutlinedInput-root': {
          borderRadius: isSmallMobile ? 1 : 2,
          fontSize: isSmallMobile ? '0.875rem' : '1rem',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main',
          },
        },
        '& .MuiInputLabel-root': {
          fontSize: isSmallMobile ? '0.875rem' : '1rem',
        },
      }
    };
    
    // Normalizar tipo de campo para manejar diferentes variantes
    const tipo = campo.tipo?.toLowerCase().replace(/_/g, '');
    
    switch (tipo) {
      case 'texto':
      case 'textocorto':
      case 'text':
      case 'string':
        return (
          <MobileFormField>
            <TextField
              {...commonProps}
              type="text"
              label={campo.etiqueta || campo.label || campo.nombre}
              value={valor}
              onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
              placeholder={campo.placeholder}
              required={campo.requerido || campo.required}
              helperText={campo.ayuda || campo.descripcion}
            />
          </MobileFormField>
        );
        
      case 'email':
      case 'correo':
        return (
          <MobileFormField>
            <TextField
              {...commonProps}
              type="email"
              label={campo.etiqueta || campo.label || campo.nombre}
              value={valor}
              onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
              placeholder={campo.placeholder}
              required={campo.requerido || campo.required}
              helperText={campo.ayuda || campo.descripcion}
            />
          </MobileFormField>
        );
        
      case 'numero':
      case 'number':
      case 'int':
      case 'integer':
      case 'float':
      case 'decimal':
        return (
          <MobileFormField>
            <TextField
              {...commonProps}
              type="number"
              label={campo.etiqueta || campo.label || campo.nombre}
              value={valor}
              onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
              placeholder={campo.placeholder}
              required={campo.requerido || campo.required}
              helperText={campo.ayuda || campo.descripcion}
              inputProps={{ 
                inputMode: 'numeric',
                pattern: '[0-9]*',
                min: campo.min,
                max: campo.max,
                step: campo.step || 1
              }}
            />
          </MobileFormField>
        );
        
      case 'fecha':
      case 'date':
      case 'datetime':
        return (
          <MobileFormField>
            <TextField
              {...commonProps}
              type="date"
              label={campo.etiqueta || campo.label || campo.nombre}
              value={valor}
              onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
              required={campo.requerido || campo.required}
              helperText={campo.ayuda || campo.descripcion}
              InputLabelProps={{ shrink: true }}
            />
          </MobileFormField>
        );
        
      case 'textolargo':
      case 'textarea':
      case 'longtext':
      case 'multiline':
        return (
          <MobileFormField>
            <TextField
              {...commonProps}
              multiline
              rows={isSmallMobile ? 3 : (campo.filas || campo.rows || 4)}
              label={campo.etiqueta || campo.label || campo.nombre}
              value={valor}
              onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
              placeholder={campo.placeholder}
              required={campo.requerido || campo.required}
              helperText={campo.ayuda || campo.descripcion}
            />
          </MobileFormField>
        );
        
      case 'select':
      case 'seleccion':
      case 'dropdown':
      case 'lista':
        return (
          <MobileFormField>
            <FormControl {...commonProps} required={campo.requerido || campo.required}>
              <InputLabel>{campo.etiqueta || campo.label || campo.nombre}</InputLabel>
              <Select
                value={valor}
                onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
                label={campo.etiqueta || campo.label || campo.nombre}
                sx={{ borderRadius: isSmallMobile ? 1 : 2 }}
              >
                <MenuItem value="">
                  <em>Seleccione una opción</em>
                </MenuItem>
                {(campo.opciones || campo.options || []).map(opcion => {
                  const value = typeof opcion === 'string' ? opcion : (opcion.valor || opcion.value);
                  const label = typeof opcion === 'string' ? opcion : (opcion.etiqueta || opcion.label || opcion.texto);
                  return (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  );
                })}
              </Select>
              {(campo.ayuda || campo.descripcion) && (
                <FormHelperText>{campo.ayuda || campo.descripcion}</FormHelperText>
              )}
            </FormControl>
          </MobileFormField>
        );
        
      case 'radio':
      case 'radiobutton':
      case 'opcion':
        return (
          <MobileFormField>
            <Paper 
              sx={{ 
                p: isSmallMobile ? 1.5 : 2, 
                bgcolor: 'grey.50', 
                borderRadius: isSmallMobile ? 1 : 2, 
                border: '1px solid', 
                borderColor: 'divider' 
              }}
            >
              <Typography variant={isSmallMobile ? "body2" : "subtitle2"} gutterBottom sx={{ fontWeight: 600 }}>
                {campo.etiqueta || campo.label || campo.nombre}
                {(campo.requerido || campo.required) && <Typography component="span" color="error"> *</Typography>}
              </Typography>
              <RadioGroup
                value={valor}
                onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
                sx={{ gap: 0.5 }}
              >
                {(campo.opciones || campo.options || []).map(opcion => {
                  const value = typeof opcion === 'string' ? opcion : (opcion.valor || opcion.value);
                  const label = typeof opcion === 'string' ? opcion : (opcion.etiqueta || opcion.label || opcion.texto);
                  return (
                    <FormControlLabel
                      key={value}
                      value={value}
                      control={<Radio size={isSmallMobile ? "small" : "medium"} />}
                      label={<Typography variant={isSmallMobile ? "body2" : "body1"}>{label}</Typography>}
                      sx={{
                        '&:hover': { bgcolor: 'action.hover', borderRadius: 1 },
                        px: 1, py: 0.5, mx: 0
                      }}
                    />
                  );
                })}
              </RadioGroup>
              {(campo.ayuda || campo.descripcion) && (
                <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                  {campo.ayuda || campo.descripcion}
                </Typography>
              )}
            </Paper>
          </MobileFormField>
        );
        
      case 'checkboxmultiple':
      case 'checkbox_multiple':
      // Redirigir al caso de checkbox con opciones
      campo.tipo = 'checkbox';
      return renderCampo(formularioId, campo);
      case 'checkbox':
      case 'check':
      case 'boolean':
      case 'bool':
        // Si tiene opciones, es checkbox mÃºltiple
        if (campo.opciones || campo.options) {
          const valoresSeleccionados = Array.isArray(valor) ? valor : [];
          return (
            <MobileFormField>
              <Paper 
                sx={{ 
                  p: isSmallMobile ? 1.5 : 2, 
                  bgcolor: 'grey.50', 
                  borderRadius: isSmallMobile ? 1 : 2, 
                  border: '1px solid', 
                  borderColor: 'divider' 
                }}
              >
                <Typography variant={isSmallMobile ? "body2" : "subtitle2"} gutterBottom sx={{ fontWeight: 600 }}>
                  {campo.etiqueta || campo.label || campo.nombre}
                  {(campo.requerido || campo.required) && <Typography component="span" color="error"> *</Typography>}
                </Typography>
                <Stack spacing={0.5}>
                  {(campo.opciones || campo.options || []).map(opcion => {
                    const value = typeof opcion === 'string' ? opcion : (opcion.valor || opcion.value);
                    const label = typeof opcion === 'string' ? opcion : (opcion.etiqueta || opcion.label || opcion.texto);
                    return (
                      <FormControlLabel
                        key={value}
                        control={
                          <Checkbox
                            size={isSmallMobile ? "small" : "medium"}
                            checked={valoresSeleccionados.includes(value)}
                            onChange={(e) => {
                              const nuevosValores = e.target.checked
                                ? [...valoresSeleccionados, value]
                                : valoresSeleccionados.filter(v => v !== value);
                              handleCampoChange(formularioId, campo.id, nuevosValores);
                            }}
                          />
                        }
                        label={<Typography variant={isSmallMobile ? "body2" : "body1"}>{label}</Typography>}
                        sx={{
                          '&:hover': { bgcolor: 'action.hover', borderRadius: 1 },
                          px: 1, py: 0.5, mx: 0
                        }}
                      />
                    );
                  })}
                </Stack>
                {(campo.ayuda || campo.descripcion) && (
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                    {campo.ayuda || campo.descripcion}
                  </Typography>
                )}
              </Paper>
            </MobileFormField>
          );
        } else {
          // Checkbox simple (sí/no)
          return (
            <MobileFormField>
              <FormControlLabel
                control={
                  <Checkbox
                    size={isSmallMobile ? "small" : "medium"}
                    checked={valor === true || valor === 'true' || valor === 1 || valor === '1'}
                    onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.checked)}
                  />
                }
                label={
                  <Typography variant={isSmallMobile ? "body2" : "body1"}>
                    {campo.etiqueta || campo.label || campo.nombre}
                    {(campo.requerido || campo.required) && <Typography component="span" color="error"> *</Typography>}
                  </Typography>
                }
              />
              {(campo.ayuda || campo.descripcion) && (
                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', pl: 4 }}>
                  {campo.ayuda || campo.descripcion}
                </Typography>
              )}
            </MobileFormField>
          );
        }
        
      case 'tabla_evaluacion':
case 'tablaevaluacion':
  const configTabla = campo.configuracion || {};
  const areas = configTabla.areas || [];
  const columnas = configTabla.columnas || [];
  
  return (
    <MobileFormField>
      <Paper sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
          {campo.etiqueta || campo.label}
        </Typography>
        
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.main' }}>
                {columnas.map((col) => (
                  <TableCell 
                    key={col.id} 
                    sx={{ 
                      color: 'white', 
                      fontWeight: 'bold',
                      width: col.ancho || 'auto' 
                    }}
                  >
                    {col.etiqueta}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {areas.map((grupo) => (
                <React.Fragment key={grupo.grupo}>
                  <TableRow>
                    <TableCell 
                      colSpan={columnas.length} 
                      sx={{ 
                        bgcolor: 'grey.200', 
                        fontWeight: 'bold' 
                      }}
                    >
                      {grupo.grupo}
                    </TableCell>
                  </TableRow>
                  {grupo.items.map((item) => (
                    <TableRow key={item.id}>
                      {columnas.map((col) => {
                        if (col.id === 'area') {
                          return (
                            <TableCell key={col.id}>
                              {item.nombre}
                            </TableCell>
                          );
                        }
                        
                        const fieldKey = `${item.id}_${col.id}`;
                        const fieldValue = datosFormularios[formularioId]?.[fieldKey] || '';
                        
                        if (col.tipo === 'texto_corto') {
                          return (
                            <TableCell key={col.id}>
                              <TextField
                                size="small"
                                fullWidth
                                value={fieldValue}
                                onChange={(e) => handleCampoChange(formularioId, fieldKey, e.target.value)}
                                placeholder={col.placeholder}
                                variant="outlined"
                              />
                            </TableCell>
                          );
                        }
                        
                        if (col.tipo === 'texto_largo') {
                          return (
                            <TableCell key={col.id}>
                              <TextField
                                size="small"
                                fullWidth
                                multiline
                                rows={2}
                                value={fieldValue}
                                onChange={(e) => handleCampoChange(formularioId, fieldKey, e.target.value)}
                                placeholder={col.placeholder}
                                variant="outlined"
                              />
                            </TableCell>
                          );
                        }
                        
                        return <TableCell key={col.id}>-</TableCell>;
                      })}
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </MobileFormField>
  );

  case 'tabla_dinamica':
  case 'tabladinamica':
    const configDinamica = campo.configuracion || {};
    const columnasDinamicas = configDinamica.columnas || [];
    const filasDinamicas = datosFormularios[formularioId]?.[campo.id] || [{}];
    
    return (
      <MobileFormField>
        <Paper sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
            {campo.etiqueta || campo.label}
          </Typography>
          
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: 'primary.main' }}>
                  {columnasDinamicas.map((col) => (
                    <TableCell 
                      key={col.id} 
                      sx={{ 
                        color: 'white', 
                        fontWeight: 'bold',
                        width: col.ancho || 'auto' 
                      }}
                    >
                      {col.etiqueta}
                    </TableCell>
                  ))}
                  <TableCell sx={{ color: 'white', width: 50 }}>
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filasDinamicas.map((fila, indexFila) => (
                  <TableRow key={indexFila}>
                    {columnasDinamicas.map((col) => {
                      const valor = fila[col.id] || '';
                      
                      return (
                        <TableCell key={col.id}>
                          <TextField
                            size="small"
                            fullWidth
                            multiline={col.tipo === 'texto_largo'}
                            rows={col.tipo === 'texto_largo' ? 2 : 1}
                            value={valor}
                            onChange={(e) => {
                              const nuevasFilas = [...filasDinamicas];
                              nuevasFilas[indexFila] = {
                                ...nuevasFilas[indexFila],
                                [col.id]: e.target.value
                              };
                              handleCampoChange(formularioId, campo.id, nuevasFilas);
                            }}
                            placeholder={col.placeholder}
                            variant="outlined"
                          />
                        </TableCell>
                      );
                    })}
                    <TableCell>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          const nuevasFilas = filasDinamicas.filter((_, i) => i !== indexFila);
                          handleCampoChange(formularioId, campo.id, nuevasFilas.length ? nuevasFilas : [{}]);
                        }}
                        disabled={filasDinamicas.length <= 1}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          {configDinamica.permitir_agregar && (
            <Button
              startIcon={<AddIcon />}
              onClick={() => {
                const nuevasFilas = [...filasDinamicas, {}];
                handleCampoChange(formularioId, campo.id, nuevasFilas);
              }}
              sx={{ mt: 2 }}
              variant="outlined"
              size="small"
            >
              {configDinamica.texto_agregar || 'Agregar fila'}
            </Button>
          )}
        </Paper>
      </MobileFormField>
    );
    
    case 'tablaplanterapeutico':
case 'tablaplan':
  return (
    <MobileFormField>
      <TablaPlanTerapeutico
        campo={campo}
        value={datosFormularios[formularioId]?.[campo.id] || []}
        onChange={(value) => handleCampoChange(formularioId, campo.id, value)}
        disabled={estaFormularioCerrado}
      />
    </MobileFormField>
  );

case 'seleccionobjetivopadre':
case 'objetivopadre':
  const respuestaActual = respuestasExistentes[formularioId];
  const parentIdFromProps = parentRespuestaId;
  const parentIdFromRespuesta = respuestaActual?.parent_respuesta_id;
  const parentIdAutomatico = datosFormularios._parentRespuestaIdAutomatico;


  const parentIdToUse = parentIdFromProps || parentIdFromRespuesta || parentIdAutomatico;
  
  // IMPORTANTE: Obtener el valor actual y asegurar que sea un array para multiselección
  const valorActual = datosFormularios[formularioId]?.[campo.id];
  const valorParaMultiselect = Array.isArray(valorActual) ? valorActual : (valorActual ? [valorActual] : []);
  
  if (!parentIdToUse) {
    return (
      <MobileFormField>
        <Alert severity="warning">
          <Typography variant="body2" gutterBottom>
            <strong>No se encontró un Plan TerapÃ©utico cerrado</strong>
          </Typography>
          <Typography variant="caption" component="div">
            Para poder seleccionar objetivos específicos, primero debe:
          </Typography>
          <ol style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>Completar el formulario "Plan TerapÃ©utico General"</li>
            <li>Cerrar el formulario una vez completado</li>
            <li>Luego podrÃ¡ acceder a este formulario de seguimiento</li>
          </ol>
        </Alert>
      </MobileFormField>
    );
  }
  
  // Determinar si debe ser multiselección basado en la configuración del campo
  const esMultiseleccion = campo.configuracion?.multiselect !== false; // Por defecto true para este tipo
  
  return (
    <MobileFormField>
      <SeleccionObjetivoPadre
        campo={{
          ...campo,
          historia_especialidad_id: historiaEspecialidadId,
          especialidad_id: especialidadId
        }}
        value={esMultiseleccion ? valorParaMultiselect : (valorActual || '')}
        onChange={(value) => handleCampoChange(formularioId, campo.id, value)}
        parentRespuestaId={parentIdToUse}
        disabled={estaFormularioCerrado}
        respuestasAnteriores={[]}
        multiselect={esMultiseleccion}
        maxSelecciones={15}
        modoVisualizacion="lista"
      />
    </MobileFormField>
  );

case 'tablaevaluacionmensual':
case 'evaluacionmensual':
case 'tabla_evaluacion_mensual':
  const respuestaFormularioEval = respuestasExistentes[formularioId];
  const parentIdPropsEval = parentRespuestaId;
  const parentIdRespuestaEval = respuestaFormularioEval?.parent_respuesta_id;
  const parentIdAutomaticoEval = datosFormularios._parentRespuestaIdAutomatico;
  
  const parentIdToUseEval = parentIdPropsEval || parentIdRespuestaEval || parentIdAutomaticoEval;
  
  if (!parentIdToUseEval) {
    return (
      <MobileFormField>
        <Alert severity="warning">
          <Typography variant="body2" gutterBottom>
            <strong>No se encontró un Plan TerapÃ©utico cerrado</strong>
          </Typography>
          <Typography variant="caption" component="div">
            Para poder evaluar objetivos específicos, primero debe:
          </Typography>
          <ol style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>Completar el formulario "Plan TerapÃ©utico Integral"</li>
            <li>Cerrar el formulario una vez completado</li>
            <li>Luego podrÃ¡ acceder a este formulario de evaluación</li>
          </ol>
        </Alert>
      </MobileFormField>
    );
  }
  
  return (
    <MobileFormField>
      <TablaEvaluacionMensual
        campo={campo}
        value={datosFormularios[formularioId]?.[campo.id] || {}}
        onChange={(value) => handleCampoChange(formularioId, campo.id, value)}
        parentRespuestaId={parentIdToUseEval}
        disabled={estaFormularioCerrado}
      />
    </MobileFormField>
  );

  case 'tablamemoriacompleja':
case 'tabla_memoria_compleja':
  return (
    <MobileFormField>
      <TablaMemoriaCompleja
        campo={campo}
        value={datosFormularios[formularioId]?.[campo.id] || {}}
        onChange={(value) => handleCampoChange(formularioId, campo.id, value)}
        disabled={estaFormularioCerrado}
      />
    </MobileFormField>
  );

case 'listaobjetivos':
  // Para el campo de objetivos específicos dentro de tabla_plan_terapeutico
  return null; // Este se maneja dentro de TablaPlanTerapeutico
case 'mes':
case 'month':
  return (
    <MobileFormField>
      <TextField
        {...commonProps}
        type="month"
        label={campo.etiqueta || campo.label || campo.nombre}
        value={valor}
        onChange={(e) => handleCampoChange(formularioId, campo.id, e.target.value)}
        required={campo.requerido || campo.required}
        helperText={campo.ayuda || campo.descripcion}
        InputLabelProps={{ shrink: true }}
      />
    </MobileFormField>
  );

// Para tabla_plan_neuro (similar a tabla_plan_terapeutico)
case 'tablapllanneuro':
case 'tablaneuro':
  return (
    <MobileFormField>
      <TablaPlanTerapeutico
        campo={campo}
        value={datosFormularios[formularioId]?.[campo.id] || []}
        onChange={(value) => handleCampoChange(formularioId, campo.id, value)}
        disabled={estaFormularioCerrado}
      />
    </MobileFormField>
  );

// Para tablas genÃ©ricas
case 'tablaevaluacionlibre':
case 'tablacheckbox':
  // Usar el componente de tabla dinÃ¡mica existente
  return renderTablaDinamica(formularioId, campo);

case 'tablaseguimientomensual':
case 'tabla_seguimiento_mensual':
  // Similar lógica para tabla de seguimiento
  const respuestaSeguimiento = respuestasExistentes[formularioId];
  const parentIdParaSeguimiento = parentRespuestaId || 
                                  respuestaSeguimiento?.parent_respuesta_id || 
                                  datosFormularios._parentRespuestaIdAutomatico;
  
  // Inicializar el valor si no existe
  const valorCampo = datosFormularios[formularioId]?.[campo.id] || {
    mes_trabajo: format(new Date(), 'yyyy-MM'),
    objetivos_seleccionados: [],
    seguimientos: {},
    objetivos_bloqueados: {},
    estado: 'abierto'
  };

  return (
    <MobileFormField>
      <TablaSeguimientoMensual
        campo={campo}
        value={valorCampo}
        onChange={(value) => {

          handleCampoChange(formularioId, campo.id, value);
        }}
        parentRespuestaId={parentIdParaSeguimiento}
        disabled={estaFormularioCerrado}
      />
    </MobileFormField>
  );

case 'dashboard_estadistico_neuro':
case 'dashboardestadisticoneuro':
  const campoOrigenDatos = campo.configuracion?.origen_datos || 'objetivos_mensuales_neuro';
  const datosParaDashboard = datosFormularios[formularioId]?.[campoOrigenDatos] || {};
  const parentIdDashboard = parentRespuestaId || 
                           respuestasExistentes[formularioId]?.parent_respuesta_id || 
                           datosFormularios._parentRespuestaIdAutomatico;
  
  return (
    <MobileFormField>
      <DashboardEstadisticoNeuro
        data={datosParaDashboard}
        parentRespuestaId={parentIdDashboard}
        periodo={datosFormularios[formularioId]?.mes_trabajo_neuro}
      />
    </MobileFormField>
  );
  
      default:
        console.warn(`Tipo de campo no reconocido: ${campo.tipo}`);
        return (
          <Alert severity="warning" sx={{ borderRadius: isSmallMobile ? 1 : 2, mb: 2 }}>
            Tipo de campo no soportado: {campo.tipo}
          </Alert>
        );
    }
  };

  // Renderizar campo en modo solo lectura
  const renderCampoSoloLectura = (formularioId, campo) => {
  const valor = datosFormularios[formularioId]?.[campo.id] || '';
  
  // Manejar tabla_plan_terapeutico y campos con objetivos_especificos
  if (campo.tipo === 'tabla_plan_terapeutico' || campo.tipo === 'tablaplanterapeutico') {
    const areas = Array.isArray(valor) ? valor : [];
    
    return (
      <MobileFormField>
        <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50', border: '1px solid', borderColor: 'grey.300' }}>
          <Typography variant="caption" color="textSecondary" gutterBottom>
            {campo.etiqueta || campo.label}
          </Typography>
          
          {areas.length === 0 ? (
            <Typography variant="body2" color="textSecondary">Sin Ã¡reas registradas</Typography>
          ) : (
            areas.map((area, index) => (
              <Box key={index} sx={{ mb: 2, p: 2, bgcolor: 'white', borderRadius: 1, border: '1px solid', borderColor: 'grey.200' }}>
                <Typography variant="body2" fontWeight="bold" gutterBottom>
                  Ãrea {area.numero || index + 1}: {area.area || area.area_intervenir || 'Sin nombre'}
                </Typography>
                
                {area.objetivos_generales && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="textSecondary">
                      Objetivos Generales:
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                      {area.objetivos_generales}
                    </Typography>
                  </Box>
                )}
                
                {area.objetivos_especificos && (
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" color="textSecondary" gutterBottom>
                      Objetivos Específicos:
                    </Typography>
                    
                    {/* Manejar ambos formatos: string y array de objetos */}
                    {typeof area.objetivos_especificos === 'string' ? (
                      <Typography variant="body2" component="div" sx={{ pl: 2, whiteSpace: 'pre-line' }}>
                        {area.objetivos_especificos}
                      </Typography>
                    ) : Array.isArray(area.objetivos_especificos) ? (
                      area.objetivos_especificos.map((obj, objIndex) => {
                        // Si es un objeto con estructura completa
                        if (typeof obj === 'object' && obj !== null) {
                          return (
                            <Box key={objIndex} sx={{ ml: 2, mb: 1.5, p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
                              <Typography variant="body2" fontWeight="medium">
                                {objIndex + 1}. {obj.texto || 'Sin texto'}
                              </Typography>
                              
                              {obj.estrategias_actividades && (
                                <Box sx={{ mt: 0.5, ml: 2 }}>
                                  <Typography variant="caption" color="textSecondary">
                                    Estrategias:
                                  </Typography>
                                  <Typography variant="caption" component="div">
                                    {obj.estrategias_actividades}
                                  </Typography>
                                </Box>
                              )}
                              
                              {obj.metas_medicion && (
                                <Box sx={{ mt: 0.5, ml: 2 }}>
                                  <Typography variant="caption" color="textSecondary">
                                    Metas:
                                  </Typography>
                                  <Typography variant="caption" component="div">
                                    {obj.metas_medicion}
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          );
                        }
                        // Si es un string simple dentro del array
                        return (
                          <Typography key={objIndex} variant="body2" sx={{ ml: 2 }}>
                            {objIndex + 1}. {obj}
                          </Typography>
                        );
                      })
                    ) : null}
                  </Box>
                )}
              </Box>
            ))
          )}
        </Paper>
      </MobileFormField>
    );
  }
  
  // Manejar tabla_seguimiento_mensual
  if (campo.tipo === 'tabla_seguimiento_mensual' || campo.tipo === 'tablaseguimientomensual') {
    const valorTabla = datosFormularios[formularioId]?.[campo.id] || {};
    
    return (
      <MobileFormField>
        <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50', border: '1px solid', borderColor: 'grey.300' }}>
          <Typography variant="caption" color="textSecondary" gutterBottom>
            {campo.etiqueta || campo.label}
          </Typography>
          
          {valorTabla.mes_trabajo && (
            <Typography variant="body2" gutterBottom>
              <strong>Mes:</strong> {format(new Date(valorTabla.mes_trabajo), 'MMMM yyyy', { locale: es })}
            </Typography>
          )}
          
          {valorTabla.objetivos_seleccionados && valorTabla.objetivos_seleccionados.length > 0 && (
            <Box mt={1}>
              <Typography variant="caption" color="textSecondary">
                Objetivos trabajados: {valorTabla.objetivos_seleccionados.length}
              </Typography>
              
              {valorTabla.seguimientos && Object.keys(valorTabla.seguimientos).map(objId => {
                const historial = valorTabla.seguimientos[objId] || [];
                const ultimoEstado = historial.length > 0 ? 
                  historial[historial.length - 1].estado : null;
                
                return (
                  <Box key={objId} sx={{ mt: 1 }}>
                    <Chip 
                      size="small"
                      label={`Objetivo ${objId}: ${ultimoEstado || 'Sin evaluar'}`}
                      color={ultimoEstado === 'logrado' ? 'success' : 'warning'}
                    />
                  </Box>
                );
              })}
            </Box>
          )}
        </Paper>
      </MobileFormField>
    );
  }
  
  // Para otros tipos de campos (manejo genÃ©rico)
  return (
    <MobileFormField>
      <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50', border: '1px solid', borderColor: 'grey.300' }}>
        <Typography variant="caption" color="textSecondary" gutterBottom>
          {campo.etiqueta || campo.label}
        </Typography>
        <Typography variant="body1">
          {/* Manejar diferentes tipos de valores */}
          {(() => {
            if (valor === null || valor === undefined || valor === '') {
              return 'No registrado';
            }
            
            // Si es un array
            if (Array.isArray(valor)) {
              // Si es array de objetos, mostrar resumen
              if (valor.length > 0 && typeof valor[0] === 'object') {
                return `${valor.length} elemento(s) registrado(s)`;
              }
              // Si es array simple
              return valor.join(', ');
            }
            
            // Si es un objeto
            if (typeof valor === 'object') {
              // Intentar mostrar un resumen del objeto
              const keys = Object.keys(valor);
              if (keys.length === 0) return 'Sin datos';
              return `Datos complejos (${keys.length} campos)`;
            }
            
            // Para valores simples (string, number, boolean)
            return String(valor);
          })()}
        </Typography>
      </Paper>
    </MobileFormField>
  );
};

const renderTablaDinamica = (formularioId, campo) => {
  const valor = datosFormularios[formularioId]?.[campo.id] || [];
  const config = campo.configuracion || {};
  const columnas = config.columnas || [];
  
  // Asegurar que valor sea un array
  const filas = Array.isArray(valor) ? valor : [];
  
  return (
    
    <MobileFormField>
      <Paper sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
          {campo.etiqueta || campo.label}
        </Typography>
        
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.main' }}>
                {columnas.map((col) => (
                  <TableCell key={col.id} sx={{ color: 'white', fontWeight: 'bold' }}>
                    {col.etiqueta}
                  </TableCell>
                ))}
                <TableCell sx={{ color: 'white', width: 50 }}>
                  Acciones
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filas.map((fila, indexFila) => (
                <TableRow key={indexFila}>
                  {columnas.map((col) => {
                    const valorCelda = fila[col.id] || '';
                    
                    // Renderizar segÃºn el tipo de columna
                    if (col.tipo === 'checkbox') {
                      return (
                        <TableCell key={col.id}>
                          <Checkbox
                            size="small"
                            checked={valorCelda === true || valorCelda === 'true' || valorCelda === 1}
                            onChange={(e) => {
                              const nuevasFilas = [...filas];
                              nuevasFilas[indexFila] = {
                                ...nuevasFilas[indexFila],
                                [col.id]: e.target.checked
                              };
                              handleCampoChange(formularioId, campo.id, nuevasFilas);
                            }}
                          />
                        </TableCell>
                      );
                    } else if (col.tipo === 'select' && col.opciones) {
                      return (
                        <TableCell key={col.id}>
                          <Select
                            size="small"
                            fullWidth
                            value={valorCelda}
                            onChange={(e) => {
                              const nuevasFilas = [...filas];
                              nuevasFilas[indexFila] = {
                                ...nuevasFilas[indexFila],
                                [col.id]: e.target.value
                              };
                              handleCampoChange(formularioId, campo.id, nuevasFilas);
                            }}
                          >
                            <MenuItem value="">-</MenuItem>
                            {col.opciones.map(opt => (
                              <MenuItem key={opt.valor} value={opt.valor}>
                                {opt.etiqueta}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                      );
                    } else {
                      // Campo de texto por defecto
                      return (
                        <TableCell key={col.id}>
                          <TextField
                            size="small"
                            fullWidth
                            multiline={col.tipo === 'texto_largo'}
                            rows={col.tipo === 'texto_largo' ? 2 : 1}
                            value={valorCelda}
                            onChange={(e) => {
                              const nuevasFilas = [...filas];
                              nuevasFilas[indexFila] = {
                                ...nuevasFilas[indexFila],
                                [col.id]: e.target.value
                              };
                              handleCampoChange(formularioId, campo.id, nuevasFilas);
                            }}
                            placeholder={col.placeholder}
                            variant="outlined"
                          />
                        </TableCell>
                      );
                    }
                  })}
                  <TableCell>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => {
                        const nuevasFilas = filas.filter((_, i) => i !== indexFila);
                        handleCampoChange(formularioId, campo.id, nuevasFilas.length ? nuevasFilas : [{}]);
                      }}
                      disabled={filas.length <= 1}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        {config.permitir_agregar !== false && (
          <Button
            startIcon={<AddIcon />}
            onClick={() => {
              const nuevaFila = {};
              columnas.forEach(col => {
                nuevaFila[col.id] = col.tipo === 'checkbox' ? false : '';
              });
              const nuevasFilas = [...filas, nuevaFila];
              handleCampoChange(formularioId, campo.id, nuevasFilas);
            }}
            sx={{ mt: 2 }}
            variant="outlined"
            size="small"
          >
            {config.texto_agregar || 'Agregar fila'}
          </Button>
        )}
      </Paper>
    </MobileFormField>
  );
};

  // ðŸ”§ MODIFICACIÃ“N 3: Renderizar sección mejorada para móvil CON LÃ“GICA PSICOTERAPIA
  const renderSeccion = (formulario, seccion, estructura) => {
    const seccionKey = `${formulario.id}-${seccion.id}`;
    const isExpanded = seccionesExpanded[seccionKey];
    const isGuardando = guardando[seccionKey];
    
    const datosFormulario = datosFormularios[formulario.id] || {};
    
    // Obtener los campos de esta sección de forma mÃ¡s robusta
    let camposDeSeccion = [];
    
    // Primero intentar obtener campos directamente de la sección
    if (seccion.campos && Array.isArray(seccion.campos)) {
      camposDeSeccion = seccion.campos;
    } 
    // Si no, buscar en la estructura general
    else if (estructura && estructura.campos) {
      camposDeSeccion = estructura.campos.filter(campo => 
        campo.seccion_id === seccion.id
      );
    }

   if (seccion.id === 'revision_sistematica') {

      camposDeSeccion.forEach(campo => {

      });
    }
    
    const tieneContenido = camposDeSeccion.some(campo => {
  if (!campo) return false;
  
  const valor = datosFormulario[campo.id];
  
  // CASO ESPECIAL: tabla_evaluacion que se guarda descompuesta
  if (campo.tipo === 'tabla_evaluacion' || campo.tipo === 'tablaevaluacion') {
    // Si el valor directo no existe, buscar campos relacionados con sufijo _observaciones
    if (!valor) {
      const camposRelacionados = Object.keys(datosFormulario).filter(key => 
        key.endsWith('_observaciones')
      );
      
      return camposRelacionados.some(key => {
        const valorCampo = datosFormulario[key];
        return typeof valorCampo === 'string' && valorCampo.trim().length > 0;
      });
    }
  }
  
  if (!valor) return false;
  
  // Para otros tipos de campos
  if (typeof valor === 'string') {
    return valor.trim().length > 0;
  }
  
  if (Array.isArray(valor)) {
    return valor.length > 0 && valor.some(item => {
      if (typeof item === 'string') return item.trim().length > 0;
      if (typeof item === 'object') return Object.values(item).some(v => 
        typeof v === 'string' && v.trim().length > 0
      );
      return !!item;
    });
  }
  
  if (typeof valor === 'object') {
    return Object.values(valor).some(v => {
      if (typeof v === 'string') return v.trim().length > 0;
      if (Array.isArray(v)) return v.length > 0;
      return !!v;
    });
  }
  
  return !!valor;
});
 
    
    const respuestaExistente = respuestasExistentes[formulario.id];
    const estaFormularioCerrado = respuestaExistente && estadosFormularios[respuestaExistente.id] === 'cerrado';
    const esAdmin = user?.rol_id === 1;
    
    const esFormularioEditable = respuestaExistente?.esEditable !== false;
    const puedeReabrirPsicoterapia = esPsicoterapia && estaFormularioCerrado;
    const puedeReabrirAdmin = !esPsicoterapia && esAdmin && estaFormularioCerrado;

    
    return (
      <Card 
        key={seccionKey}
        variant="outlined"
        sx={{ 
          mb: 2,
          borderRadius: isSmallMobile ? 1 : 2,
          borderColor: estaFormularioCerrado ? 'grey.400' : (tieneContenido ? 'success.main' : 'divider'),
          opacity: estaFormularioCerrado && !esAdmin ? 0.8 : 1,
        }}
      >
        <CardContent sx={{ pb: isSmallMobile ? 1 : 2 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Box display="flex" alignItems="center" gap={1}>
              <Avatar 
                sx={{ 
                  bgcolor: estaFormularioCerrado ? 'grey.500' : (tieneContenido ? 'success.main' : 'grey.400'),
                  width: isSmallMobile ? 24 : 32, 
                  height: isSmallMobile ? 24 : 32,
                  fontSize: isSmallMobile ? 12 : 14 
                }}
              >
                {estaFormularioCerrado ? <LockIcon fontSize="small" /> : 
                 tieneContenido ? <CheckCircleIcon fontSize="small" /> : 
                 <EditIcon fontSize="small" />}
              </Avatar>
              
              <Box>
                <Typography 
                  variant={isSmallMobile ? "subtitle2" : "subtitle1"} 
                  sx={{ fontWeight: 600 }}
                >
                  {seccion.titulo}
                </Typography>
                {seccion.descripcion && !isSmallMobile && (
                  <Typography variant="caption" color="textSecondary">
                    {seccion.descripcion}
                  </Typography>
                )}
              </Box>
            </Box>
            
            <Box display="flex" gap={1} alignItems="center">
              {camposDeSeccion.length === 0 && (
                <Chip 
                  label="Sin campos" 
                  color="warning" 
                  size="small"
                />
              )}
              
              {estaFormularioCerrado && (
                <Chip 
                  label="Cerrado" 
                  color="default" 
                  size="small"
                  icon={<LockIcon />}
                />
              )}
              
              {tieneContenido && !estaFormularioCerrado && (
                <Chip 
                  label={isSmallMobile ? "âœ“" : "Completado"} 
                  color="success" 
                  size="small"
                  icon={!isSmallMobile ? <CheckCircleIcon /> : undefined}
                />
              )}
              
              <IconButton
                size="small"
                onClick={() => toggleSeccion(formulario.id, seccion.id)}
              >
                {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
          </Box>
          
          <Collapse in={isExpanded} timeout={300}>
            <Box sx={{ pt: 2 }}>
              {/* Mostrar alerta si estÃ¡ cerrado */}
              {estaFormularioCerrado && (
                <>
                  {/* Botón específico para psicoterapia */}
                  {puedeReabrirPsicoterapia && (
                    <Button
                      variant="contained"
                      color="primary"
                      size={isSmallMobile ? "medium" : "large"}
                      fullWidth={isMobile}
                      startIcon={<EditIcon />}
                      onClick={() => reabrirYEditarPsicoterapia(respuestaExistente.id, formulario.nombre)}
                      disabled={procesandoEstado[respuestaExistente.id]}
                      sx={{
                        borderRadius: isSmallMobile ? 2 : 3,
                        px: isSmallMobile ? 2 : 3,
                        py: isSmallMobile ? 1 : 1.5,
                        textTransform: 'none',
                        fontWeight: 600,
                      }}
                    >
                      Reabrir y Editar
                    </Button>
                  )}
                  
                  {/* Botón admin para otras especialidades */}
                  {puedeReabrirAdmin && (
                    <Button
                      variant="contained"
                      color="primary"
                      size={isSmallMobile ? "medium" : "large"}
                      fullWidth={isMobile}
                      startIcon={<LockOpenIcon />}
                      onClick={() => reabrirFormulario(respuestaExistente.id, formulario.nombre)}
                      disabled={procesandoEstado[respuestaExistente.id]}
                      sx={{
                        borderRadius: isSmallMobile ? 2 : 3,
                        px: isSmallMobile ? 2 : 3,
                        py: isSmallMobile ? 1 : 1.5,
                        textTransform: 'none',
                        fontWeight: 600,
                      }}
                    >
                      Reabrir Formulario
                    </Button>
                  )}
                </>
              )}
              
              {/* Verificar si hay campos para mostrar */}
              {camposDeSeccion.length === 0 ? (
                <Alert severity="warning" sx={{ mb: 2, borderRadius: 1 }}>
                  Esta sección no tiene campos configurados.
                </Alert>
              ) : (
                <>
                  {/* Campos en modo lectura si estÃ¡ cerrado */}
                  {isMobile ? (
                    <Stack spacing={isSmallMobile ? 1 : 2}>
                      {camposDeSeccion
                        .filter(campo => campo && campo.id)
                        .map(campo => (
                        <Box key={campo.id}>
                          {estaFormularioCerrado ? 
                            renderCampoSoloLectura(formulario.id, campo) : 
                            renderCampo(formulario.id, campo)
                          }
                        </Box>
                      ))}
                    </Stack>
                  ) : (
                    <Grid container spacing={3}>
                      {camposDeSeccion
                        .filter(campo => campo && campo.id)
                        .map(campo => (
                        <Grid 
                          item 
                          xs={12} 
                          md={
                            campo.ancho === 'completo' || 
                            campo.tipo === 'texto_largo' || 
                            campo.tipo === 'textarea' ||
                            campo.tipo === 'longtext' ||
                            campo.tipo === 'multiline' ||
                            campo.tipo === 'textolargo' ||

                            campo.tipo === 'tabla_plan_terapeutico' ||
                            campo.tipo === 'tablaplanterapeutico' ||
                            campo.tipo === 'seleccion_objetivo_padre' ||
                            campo.tipo === 'seleccionobjetivopadre' ||
                            campo.tipo === 'tabla_evaluacion_mensual' ||
                            campo.tipo === 'tabla_seguimiento_mensual' || 
                            campo.tipo === 'tablaseguimientomensual' || 
                            campo.tipo === 'tablaevaluacionmensual' ||

                            campo.tipo === 'tabla_plan_neuro' ||
                            campo.tipo === 'tablapllanneuro' ||
                            campo.tipo === 'tabla_evaluacion_libre' ||
                            campo.tipo === 'tablaevaluacionlibre' ||
                            campo.tipo === 'tabla_memoria_compleja' ||
                            campo.tipo === 'tablamemoriacompleja' ||
                            campo.tipo === 'tabla_checkbox' ||
                            campo.tipo === 'tablacheckbox' ||

                            campo.tipo === 'tabla_evaluacion' ||
                            campo.tipo === 'tablaevaluacion' ||
                            campo.tipo === 'tabla_dinamica' ||
                            campo.tipo === 'tabladinamica' ? 12 : 6
                            
                          } 
                          key={campo.id}
                        >
                          {estaFormularioCerrado ? 
                            renderCampoSoloLectura(formulario.id, campo) : 
                            renderCampo(formulario.id, campo)
                          }
                        </Grid>
                      ))}
                    </Grid>
                  )}
                  
                  <Divider sx={{ my: isSmallMobile ? 2 : 3 }} />
                  
                  {/* ðŸ”§ BOTONES DE ACCIÃ“N - MODIFICACIÃ“N PRINCIPAL */}
                  <Box display="flex" justifyContent="flex-end" gap={2} flexWrap="wrap">
                    {!estaFormularioCerrado ? (
                      <>
                        <Button
                          variant="contained"
                          size={isSmallMobile ? "medium" : "large"}
                          fullWidth={isMobile}
                          startIcon={isGuardando ? <CircularProgress size={16} /> : <SaveIcon />}
                          onClick={() => guardarSeccion(formulario.id, seccion.id)}
                          disabled={isGuardando || camposDeSeccion.length === 0}
                          sx={{
                            borderRadius: isSmallMobile ? 2 : 3,
                            px: isSmallMobile ? 2 : 3,
                            py: isSmallMobile ? 1 : 1.5,
                            textTransform: 'none',
                            fontWeight: 600,
                          }}
                        >
                          {isGuardando ? 'Guardando...' : 'Guardar Sección'}
                        </Button>

                        {/* Mostrar botón cerrar solo si hay respuesta y estÃ¡ en la Ãºltima sección */}
                        {respuestaExistente && estructura.secciones.indexOf(seccion) === estructura.secciones.length - 1 && (
                          <Button
                            variant="outlined"
                            color="error"
                            size={isSmallMobile ? "medium" : "large"}
                            startIcon={<LockIcon />}
                            onClick={() => cerrarFormulario(respuestaExistente.id, formulario.nombre)}
                            disabled={procesandoEstado[respuestaExistente.id]}
                            sx={{
                              borderRadius: isSmallMobile ? 2 : 3,
                              px: isSmallMobile ? 2 : 3,
                              py: isSmallMobile ? 1 : 1.5,
                              textTransform: 'none',
                              fontWeight: 600,
                            }}
                          >
                            Cerrar Formulario
                          </Button>
                        )}
                      </>
                    ) : (
                      // ðŸ”§ BOTONES CUANDO ESTÃ CERRADO - LÃ“GICA POR ESPECIALIDAD
                      <>
                        {/* Botón específico para psicoterapia */}
                        {esPsicoterapia && (
                          <Button
                            variant="contained"
                            color="primary"
                            size={isSmallMobile ? "medium" : "large"}
                            fullWidth={isMobile}
                            startIcon={<EditIcon />}
                            onClick={() => reabrirYEditarPsicoterapia(respuestaExistente.id, formulario.nombre)}
                            disabled={procesandoEstado[respuestaExistente.id]}
                            sx={{
                              borderRadius: isSmallMobile ? 2 : 3,
                              px: isSmallMobile ? 2 : 3,
                              py: isSmallMobile ? 1 : 1.5,
                              textTransform: 'none',
                              fontWeight: 600,
                            }}
                          >
                            Reabrir y Editar
                          </Button>
                        )}
                        
                        {/* Botón admin para otras especialidades */}
                        {!esPsicoterapia && esAdmin && (
                          <Button
                            variant="contained"
                            color="primary"
                            size={isSmallMobile ? "medium" : "large"}
                            fullWidth={isMobile}
                            startIcon={<LockOpenIcon />}
                            onClick={() => reabrirFormulario(respuestaExistente.id, formulario.nombre)}
                            disabled={procesandoEstado[respuestaExistente.id]}
                            sx={{
                              borderRadius: isSmallMobile ? 2 : 3,
                              px: isSmallMobile ? 2 : 3,
                              py: isSmallMobile ? 1 : 1.5,
                              textTransform: 'none',
                              fontWeight: 600,
                            }}
                          >
                            Reabrir Formulario
                          </Button>
                        )}
                      </>
                    )}
                  </Box>
                </>
              )}
            </Box>
          </Collapse>
        </CardContent>
      </Card>
    );
  };

   

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" p={isSmallMobile ? 4 : 6}>
        <CircularProgress size={isSmallMobile ? 40 : 60} thickness={4} />
        <Typography variant={isSmallMobile ? "body1" : "h6"} sx={{ mt: 2, color: 'text.secondary' }}>
          Cargando formularios...
        </Typography>
      </Box>
    );
  }

  if (formularios.length === 0) {
    return (
      <ResponsiveContainer>
        
        
        <Paper 
          elevation={1} 
          sx={{ 
            borderRadius: isSmallMobile ? 2 : 3,
            overflow: 'hidden',
            mx: isMobile ? 1 : 0
          }}
        >
          {/* Tab simulado para mostrar consistencia */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.50' }}>
            <StyledTabs value={0}>
              <Tab 
                label={
                  <Box display="flex" alignItems="center" gap={1}>
                    <WarningIcon fontSize="small" />
                    <Typography variant={isSmallMobile ? "caption" : "body2"}>
                      Sin formularios
                    </Typography>
                  </Box>
                }
                disabled
              />
            </StyledTabs>
          </Box>
          
          <TabPanel>
            <Box sx={{ textAlign: 'center', py: isSmallMobile ? 4 : 6 }}>
           
              
              <Typography variant={isSmallMobile ? "h6" : "h5"} gutterBottom sx={{ fontWeight: 600 }}>
                No hay formularios disponibles
              </Typography>
              
              <Alert 
                severity="info" 
                sx={{ 
                  mt: 3, 
                  textAlign: 'left',
                  borderRadius: isSmallMobile ? 1 : 2,
                  '& .MuiAlert-icon': {
                    fontSize: isSmallMobile ? 20 : 24
                  }
                }}
              >
                <Typography variant={isSmallMobile ? "body2" : "body1"}>
                  <strong>Información:</strong> Los formularios para esta etapa pueden estar configurÃ¡ndose. 
                  Contacta al administrador si crees que debería haber formularios disponibles.
                </Typography>
              </Alert>
            </Box>
          </TabPanel>
        </Paper>
      </ResponsiveContainer>
    );
  }

  const formularioActual = formularios[tabActual];

  return (
    <ResponsiveContainer>
    
      
       
      {/* Contenedor de tabs - Responsive */}
      <Paper 
        elevation={1} 
        sx={{ 
          borderRadius: isSmallMobile ? 2 : 3,
          overflow: 'hidden',
          mx: isMobile ? 1 : 0
        }}
      >
        {/* Navegación por tabs - Diferente para móvil */}
        {isMobile ? (
          <>
            <Box sx={{ 
              borderBottom: 1, 
              borderColor: 'divider',
              bgcolor: 'background.paper',
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <Button
                fullWidth
                variant="text"
                onClick={() => setDrawerOpen(true)}
                startIcon={<MenuIcon />}
                endIcon={<ExpandMoreIcon />}
                sx={{
                  justifyContent: 'space-between',
                  textTransform: 'none',
                  color: 'text.primary',
                }}
              >
                <Box textAlign="left">
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    {formularioActual?.nombre || 'Seleccionar formulario'}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Formulario {tabActual + 1} de {formularios.length}
                  </Typography>
                </Box>
              </Button>
            </Box>
            <MobileFormulariosDrawer />
          </>
        ) : (
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <StyledTabs
              value={tabActual}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              {formularios.filter(f => f && f.id).map((formulario, index) => {
                const respuesta = respuestasExistentes[formulario.id];
                const estado = respuesta ? estadosFormularios[respuesta.id] : null;
                
                return (
                  <Tab
                    key={formulario.id}
                    icon={getFormularioIcon(formulario)}
                    iconPosition="start"
                    label={
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body2" fontWeight="medium">
                          {formulario.nombre}
                          {estado === 'cerrado' && ' (Cerrado)'}
                        </Typography>
                        {formulario.requerido_en_etapa && (
                          <StarIcon fontSize="small" color="warning" />
                        )}
                      </Box>
                    }
                  />
                );
              })}
            </StyledTabs>
          </Box>
        )}

        {/* Contenido del formulario seleccionado */}
        {formularioActual && (
          <TabPanel>
            <Fade in={true} timeout={300}>
              <Box>
                {/* Header del formulario */}
                <Box mb={3}>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2}>
                      <Box>
                        <Typography variant={isSmallMobile ? "h6" : "h5"} gutterBottom sx={{ fontWeight: 600 }}>
                          {formularioActual.nombre}
                        </Typography>
                        {formularioActual.descripcion && (
                          <Typography variant="body2" color="textSecondary">
                            {formularioActual.descripcion}
                          </Typography>
                        )}
                      </Box>
                    
                    <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
                      {formularioActual.requerido_en_etapa && (
                        <Chip 
                          label={isSmallMobile ? "Req." : "Requerido"} 
                          color="warning" 
                          size="small"
                          icon={<StarIcon />}
                        />
                      )}
                      
                      {respuestasExistentes[formularioActual.id] && (
                        <Chip 
                          label={estadosFormularios[respuestasExistentes[formularioActual.id].id] === 'cerrado' ? 'Cerrado' : 'En progreso'} 
                          color={estadosFormularios[respuestasExistentes[formularioActual.id].id] === 'cerrado' ? 'success' : 'warning'} 
                          size="small"
                          icon={estadosFormularios[respuestasExistentes[formularioActual.id].id] === 'cerrado' ? <LockIcon /> : <EditIcon />}
                        />
                      )}
                      
                      {/* ðŸ”§ AGREGAR ESTE BOTÃ“N AQUÃ */}
                      {esPsicoterapia && 
                      respuestasExistentes[formularioActual.id] && 
                      estadosFormularios[respuestasExistentes[formularioActual.id].id] === 'cerrado' && (
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={<EditIcon />}
                          onClick={() => reabrirYEditarPsicoterapia(
                            respuestasExistentes[formularioActual.id].id, 
                            formularioActual.nombre
                          )}
                          disabled={procesandoEstado[respuestasExistentes[formularioActual.id].id]}
                          sx={{
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            px: 2,
                            py: 0.5,
                          }}
                        >
                          {isSmallMobile ? 'Editar' : 'Reabrir y Editar'}
                        </Button>
                      )}
                    </Box>
                  </Box>
                  
                  {formularioActual.instrucciones && (
                    <Alert 
                      severity="info" 
                      sx={{ 
                        mt: 2,
                        borderRadius: isSmallMobile ? 1 : 2,
                      }}
                    >
                      <Typography variant={isSmallMobile ? "body2" : "body1"}>
                        <strong>Instrucciones:</strong> {formularioActual.instrucciones}
                      </Typography>
                    </Alert>
                  )}

                  {formularioActual.tipo_dependencia === 'hijo_cualitativo' && parentRespuestaId && (
                    <Alert severity="info" sx={{ mt: 2 }}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <LinkIcon />
                        <Typography variant="body2">
                          Este formulario depende del Plan TerapÃ©utico. 
                          Los objetivos se cargan automÃ¡ticamente del plan principal.
                        </Typography>
                      </Stack>
                    </Alert>
                  )}

                </Box>

                {/* Contenido del formulario */}
                {(() => {
                  let estructura;
                  try {
                    estructura = typeof formularioActual.estructura === 'string' 
                      ? JSON.parse(formularioActual.estructura) 
                      : (formularioActual.estructura || {});
                  } catch (error) {
                    console.error('Error al parsear estructura del formulario:', error);
                    estructura = {};
                  }
                  
                  estructura.campos = estructura.campos || [];
                  estructura.secciones = estructura.secciones || [];
                  
                  if (estructura.secciones.length === 0 && estructura.campos.length > 0) {
                    estructura.secciones = [{
                      id: 'general',
                      titulo: 'Información del Formulario',
                      descripcion: '',
                      campos: estructura.campos
                    }];
                  } else {
                    estructura.secciones = estructura.secciones.map(seccion => {
                      if (!seccion.campos || seccion.campos.length === 0) {
                        seccion.campos = estructura.campos.filter(campo => 
                          campo.seccion_id === seccion.id
                        );
                      }
                      return seccion;
                    });
                    
                    const camposSinSeccion = estructura.campos.filter(campo => {
                      const tieneSeccion = estructura.secciones.some(seccion => 
                        seccion.campos && seccion.campos.some(c => c.id === campo.id)
                      );
                      return !tieneSeccion && !campo.seccion_id;
                    });
                    
                    if (camposSinSeccion.length > 0) {
                      estructura.secciones.push({
                        id: 'otros',
                        titulo: 'Información Adicional',
                        descripcion: '',
                        campos: camposSinSeccion
                      });
                    }
                  }
                  
                  return estructura.secciones.length > 0 ? (
                    <>
                      <Stack spacing={isSmallMobile ? 1 : 2}>
                        {estructura.secciones
                          .filter(seccion => seccion && seccion.id)
                          .map(seccion => renderSeccion(formularioActual, seccion, estructura))}
                      </Stack>

                      {/* AGREGAR AQUÃ LOS BOTONES PDF - DESPUÃ‰S DE TODAS LAS SECCIONES */}
                      {formularioActual.plantilla_pdf && respuestasExistentes[formularioActual.id] && (
                        <Paper elevation={2} sx={{ p: 3, mt: 3, borderRadius: 2 }}>
                          <Typography variant="h6" gutterBottom>
                            Opciones de PDF
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          
                          <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap">
                            {/* Descargar plantilla vacía */}
                            <Button
                              variant="outlined"
                              color="primary"
                              size={isSmallMobile ? "medium" : "large"}
                              startIcon={<PdfIcon />}
                              onClick={() => descargarPlantillaVacia(formularioActual)}
                              sx={{
                                borderRadius: isSmallMobile ? 2 : 3,
                                px: isSmallMobile ? 2 : 3,
                                py: isSmallMobile ? 1 : 1.5,
                                textTransform: 'none',
                                fontWeight: 600,
                              }}
                            >
                              Descargar Plantilla Vacía
                            </Button>
                            
                            {/* Generar PDF con datos */}
                            <Button
                              variant="contained"
                              color="primary"
                              size={isSmallMobile ? "medium" : "large"}
                              startIcon={procesandoPdf[formularioActual.id] ? 
                                <CircularProgress size={20} color="inherit" /> : 
                                <DownloadIcon />
                              }
                              onClick={() => generarPdfConDatos(formularioActual.id, respuestasExistentes[formularioActual.id].id)}
                              disabled={procesandoPdf[formularioActual.id]}
                              sx={{
                                borderRadius: isSmallMobile ? 2 : 3,
                                px: isSmallMobile ? 2 : 3,
                                py: isSmallMobile ? 1 : 1.5,
                                textTransform: 'none',
                                fontWeight: 600,
                              }}
                            >
                              {procesandoPdf[formularioActual.id] ? 'Generando PDF...' : 'Descargar PDF con Datos'}
                            </Button>
                          </Box>
                        </Paper>
                      )}
                    </>
                  ) : estructura.campos.length > 0 ? (
                    <Alert severity="warning" sx={{ mb: 2 }}>
                      <Typography variant="body2">
                        Este formulario tiene campos pero no tiene secciones configuradas.
                        Por favor, contacte al administrador.
                      </Typography>
                    </Alert>
                  ) : (
                    <Alert severity="error" sx={{ borderRadius: isSmallMobile ? 1 : 2 }}>
                      Este formulario no tiene campos configurados
                    </Alert>
                  );
                })()}
              </Box>
            </Fade>
          </TabPanel>
        )}
      </Paper>
    </ResponsiveContainer>
  );
};

export default FormulariosDinamicos;